/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TowHitch = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M24.65 12.92h-1a5.89 5.89 0 0 1-3.93-4.8 4.1 4.1 0 1 0-2.7 0 5.89 5.89 0 0 1-3.72 4.73L9.75 2.72a1.36 1.36 0 0 0-1.27-.91H.22v2.7h7.3l3.55 10.2c.19.54.697.904 1.27.91h12.31a1.35 1.35 0 0 0 0-2.7z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

TowHitch.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TowHitch.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TowHitch;
